import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-key"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "金牌合作", -1)
const _hoisted_4 = ["innerHTML"]

import { AdvertisementChannel } from "@/data/index.type";
import { computed } from "@vue/reactivity";

import LinkedButton from "@/components/LinkedButton.vue";
import Stars from "@/components/Stars.vue";
interface AdvertPanelSectionProps {
  title: string | number;
  data: AdvertisementChannel[];
  isActive: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AdvertPanelSection',
  props: {
    title: null,
    data: null,
    isActive: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  title: string | number;
  data: AdvertisementChannel[];
  isActive: boolean;
}



const starData = computed(() => {
  let obj: Record<string, AdvertisementChannel[] | undefined> = {};
  props.data.forEach((v) => {
    let key = v.star ?? "0";
    if (obj[key] === undefined) {
      obj[key] = [];
    }
    obj[key]!.push(v);
  });
  return obj;
});

const openUrl = (url: string) => {
  try {
    window.open(url);
  } catch {
    console.error("url不合法");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$style.section, { active: __props.isActive }]),
    "data-key": __props.title
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.body)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.header)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.title)
        }, _toDisplayString(__props.title), 3)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.content)
      }, [
        (_unref(starData)['0'] !== undefined)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(starData)['0'], (item, index) => {
              return (_openBlock(), _createBlock(LinkedButton, {
                style: _normalizeStyle(index % 5 === 0 ? 'margin: 10px 0 10px 10px' : 'margin: 10px 0 10px 20px'),
                key: item.adType,
                url: item.url,
                onClick: openUrl
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style['linked-button-inner']),
                    innerHTML: item.content
                  }, null, 10, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["style", "url"]))
            }), 128))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(starData))
            .filter((v) => v !== '0')
            .reverse(), (key) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"width":"100%"},
            key: key
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.subtitle)
            }, [
              _hoisted_3,
              _createVNode(Stars, {
                size: +key
              }, null, 8, ["size"])
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(starData)[key], (value, index) => {
              return (_openBlock(), _createBlock(LinkedButton, {
                style: _normalizeStyle(index % 5 === 0 ? 'margin: 10px 0 10px 10px' : 'margin: 10px 0 10px 20px'),
                key: value.adType,
                url: value.url,
                onClick: openUrl
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style['linked-button-inner']),
                    innerHTML: value.content
                  }, null, 10, _hoisted_4)
                ]),
                _: 2
              }, 1032, ["style", "url"]))
            }), 128))
          ]))
        }), 128))
      ], 2)
    ], 2)
  ], 10, _hoisted_1))
}
}

})